import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Bir hata oluştu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-black/12 py-4 font-body text-[#0f1115] placeholder:text-[#9aa1ac] focus:border-[#d81f2a] focus:outline-none transition-colors";

  return (
    <div className="grain min-h-screen flex bg-[#ffffff]">
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1598408745613-178751e2ccde"
          alt="DMD GRUP"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#ffffff]/70" />
        <div className="absolute bottom-12 left-12 bg-white/90 px-6 py-4 flex items-center gap-2">
          <img src="/brand/logo.png" alt="DMD Group logo" className="h-14 w-auto" />
          <span className="font-mono text-xs tracking-[0.25em] text-[#d81f2a] mt-2">INT.</span>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="w-full max-w-md"
        >
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d81f2a]">(YÖNETİM)</span>
          <h1 className="mt-6 font-display text-4xl font-bold uppercase tracking-tight text-[#0f1115]">
            Yönetim Girişi
          </h1>

          <form onSubmit={submit} data-testid="login-form" className="mt-12 space-y-8">
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-posta"
              className={inputCls}
            />
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifre"
              className={inputCls}
            />
            {error && (
              <p data-testid="login-error" className="font-mono text-xs text-red-400">
                {error}
              </p>
            )}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="group w-full inline-flex items-center justify-center gap-3 bg-[#d81f2a] text-[#ffffff] px-8 py-4 font-mono text-xs uppercase tracking-[0.15em] font-bold hover:bg-white transition-colors disabled:opacity-50"
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </form>

          <Link to="/" className="mt-10 inline-block font-mono text-xs uppercase tracking-widest text-[#5b6472] hover:text-[#0f1115] transition-colors">
            ← Siteye dön
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
